import React from 'react';

interface NavigationButtonIconProps {
  direction: 'left' | 'right';
}

const NavigationButtonIcon = ({ direction }: NavigationButtonIconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    transform={`rotate(${direction === 'right' ? '0' : '-180'})`}
    height='26'
    viewBox='0 0 17 26'
    fill='none'
  >
    <path d='M17 13L0 1.52436e-07L4.12327e-07 26L17 13Z' fill='#949494' />
  </svg>
);

export default NavigationButtonIcon;
